
import { computed, defineComponent, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { FormatMethods } from "@/helpers/data-format";

export default defineComponent({
  name: "form-Phone-modal",
  components: { VZModal },
  emits: ["close-detail"],
  props: {
    //phone: { type: Array as () => Array<IUser> },
    phone: { type: Object, default: null },
    id: { type: String, default: "kt_user_Phone" },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    let phoneObj = ref<any>(props.phone);
    const cloneData = toRef(props, "phone");
    const format = computed(() => {
      return FormatMethods;
    });
    const close = () => {
      emit("close-detail");
    };

    watch(
      cloneData,
      (newValue) => {
        phoneObj.value = newValue;
      },
      { deep: true }
    );
    return {
      t,
      close,
      format,
      phoneObj,
    };
  },
});
